app.service('simpleModal', function () {
	let $self;
	let isSimpleModalOpened = false;
	let isOneInit = false;

	function close() {
		$self.remove();
		isSimpleModalOpened = false;
	}

	function generate(params) {
		$self = $(`<div id="simple-modal-wrapper"/>`);
		const $modalContent = $(`<div class="simple-modal-content">${params.content}</div>`);
		const $closeButton = $(`<button class="simple-modal-close js-simple-modal-close"></button>`);

		$self.addClass(params.fullWidth ? 'simple-modal-full-width' : '').appendTo('body');
		$modalContent.addClass(params.classList ? params.classList : '').appendTo($self);
		$closeButton.appendTo($modalContent);

		isSimpleModalOpened = true;
		$self.on('click', function (e) {
			if ($(e.target).is(this)) {
				close();
			}
		}).on('click', '.js-simple-modal-close', function () {
			close();
		});
	}

	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$(document).on('keydown', function (e) {
				// zamykany razem ze domyslnym modalem przy uzyciu klawiatury
				if (e.keyCode === 27 && isSimpleModalOpened) { // klawisz escape
					close();
				}
			});
		}
	}

	return {
		init,
		generate
	};
});
